import consts from "consts/consts";
import { isConnectedFromLocalISP } from "helpers/localIsp";
import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { generateImageWithNewConfig } from "web-api/helpers/imageHelper";

import rectangleLogo from "../../../public/assets/logo_horizontal_nav.png";
import squareLogo from "../../../public/assets/logo_nav.png";

export const LogoTypes = {
  SQUARE: "SQUARE",
  RECTANGLE: "RECTANGLE",
};

export default class LogoNav extends Component {
  render() {
    const isLocalIsp = isConnectedFromLocalISP();

    let logoMapping;
    if (this.props.type === LogoTypes.SQUARE) {
      logoMapping = {
        main: generateImageWithNewConfig(squareLogo, LogoTypes.SQUARE),
        local: "/assets/local_logo.png",
      };
    }

    if (this.props.type === LogoTypes.RECTANGLE) {
      logoMapping = {
        main: generateImageWithNewConfig(rectangleLogo, LogoTypes.RECTANGLE),
        local: "/assets/local_logo_horizontal.png",
      };
    }

    return (
      <Fragment>
        <img
          src={isLocalIsp ? logoMapping.local : logoMapping.main}
          className={this.props.className}
          alt={`${consts.name}'s logo`}
        />
      </Fragment>
    );
  }
}

LogoNav.defaultProps = {
  type: LogoTypes.SQUARE,
};

LogoNav.propTypes = {
  type: PropTypes.oneOf(Object.values(LogoTypes)),
};
